import Vue from 'vue';
import { getProducts } from '@breakmedia/prime-vue-product/src/store/getProducts';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';

export const onPurchase = async ({ order, eventId }) => {
    let productIds = [];
    for (let i in order.OrderItems) {
        if (order.OrderItems.hasOwnProperty(i)) {
            productIds.push(order.OrderItems[i].master_catalog_item_id.toString());
        }
    }

    getProducts(
        new Observable(subscriber =>
            subscriber.next({
                ids: productIds,
                fields: `
            id
            variantsIds
            categories
            attributes
            price
        `,
            }),
        ),
    )
        .pipe(first())
        .subscribe(products => {
            let items = [];
            for (let orderItem of order.OrderItems) {
                let product;
                for (let item of products) {
                    if (orderItem.master_catalog_item_id == item.id) {
                        product = item;
                        break;
                    }
                }

                items.push({
                    ...Vue.$gtm.getProductObject(product, orderItem),
                    quantity: parseInt(orderItem.quantity),
                });
            }

            let feesTotal = Vue.$basket.getProductsFeesTotal(order.OrderItems);

            let couponAmount = 0;
            if (order.Fees) {
                for (let fee of order.Fees) {
                    if (fee.type === 'coupon') {
                        couponAmount = parseFloat(fee.value);
                        break;
                    }
                }
            }

            let couponCode;
            let paymentId;
            if (order.Options) {
                for (let option of order.Options) {
                    if (option.name === 'coupon' && option.value) {
                        couponCode = option.value;
                    } else if (option.name === 'paymentUniqueId' && option.value) {
                        paymentId = option.value;
                    }
                }
            }

            let shippingTotal = 0;
            for (let i in order.ShippingPrices) {
                if (order.ShippingPrices.hasOwnProperty(i)) {
                    let shippingPrice = order.ShippingPrices[i];
                    shippingTotal += parseFloat(shippingPrice.price);
                }
            }

            let actionField = {
                id: order.id,
                transaction_id: paymentId || order.id,
                affiliation: 'Online Store',
                revenue: parseFloat(order.price_total),
                tax: parseFloat((parseFloat(order.vat_amount) + feesTotal).toFixed(2)),
                shipping: parseFloat(shippingTotal.toFixed(2)),
                currency: 'EUR',
                payment_type: 'paypal',
            };

            if (couponCode && couponAmount) {
                actionField.coupon = couponCode;
                actionField.coupon_discount = parseFloat(
                    ((Math.abs(couponAmount) / order.price_total) * 100).toFixed(2),
                );
            }

            // UA
            Vue.$gtm.push({
                event: 'purchase',
                facebookEventID: eventId,
                ecommerce: {
                    purchase: {
                        actionField,
                        products: items,
                    },
                },
            });

            //GA4
            Vue.$gtm.push({
                event: 'purchase',
                facebookEventID: eventId,
                ecommerce: {
                    transaction_id: actionField.transaction_id,
                    affiliation: actionField.actionField,
                    value: actionField.revenue,
                    tax: actionField.tax,
                    shipping: actionField.shipping,
                    currency: actionField.currency,
                    coupon: actionField.coupon,
                    items: items,
                },
            });
        });
};
